<template>
  <div class="container">
    <div class="s-profile">
      <div class="s-profile-bg" :style="{backgroundImage:'url('+info.selfy[info.selfyIndex || 0]+')'}"></div>
      <div class="avator" :style="{backgroundImage:'url('+info.selfy[info.selfyIndex]+')'}"></div>
      <div class="s-profile-info">
        <h3>{{info.douyinName}}</h3>
        <p>抖音ID：{{info.douyinId}}</p>
        <p>抖音粉丝数:{{numberFormat(info.douyinFansCount)}}</p>
        <p class="label-group">
          <span class="s-label" v-for="(item,index) in info.category" :key="index">{{item}}</span>
        </p>
      </div>
    </div>
    <div class="s-home-cart">
        <h4 class="s-title">
          自拍照片
        </h4>
        <div class="s-figure-list-contianer">
          <ul class="s-figure-list" v-if="info.selfy && info.selfy.length">
            <li v-for="(item,index) in info.selfy" :key="index">
              <img :src="item" alt="" v-preview="1" class="preview">
            </li>
          </ul>
           <div v-else class="empty-tips">暂无作品展示</div>
        </div>
    </div>
    <div class="s-home-cart">
        <h4 class="s-title">
          作品展示
        </h4>
        <div class="s-figure-list-contianer">
          <ul class="s-figure-list" v-if="info.works && info.works.length">
            <li v-for="(item,index) in info.works" :key="index">
              <video :src="item" controls></video>
            </li>
          </ul>
          <div v-else class="empty-tips">暂无作品展示</div>
        </div>
    </div>
  </div>
</template>

<script>
import config from '@/utils/config'
import utils from '@/utils/index'
export default {
  name: 'home',
  data () {
    return {
      numberFormat: utils.numberFormat,
      swiperOption: {
        pagination: {
          el: '.swiper-pagination'
        }
      },
      info: {
        douyinId: '',
        douyinName: '',
        selfy: [],
        index: 0,
        category: []
      },
      list: []
    }
  },
  methods: {
    getInfo () {
      this.$http.get(`${config.HOST}douyin/v1/kol/getKol?id=${this.$route.params.id}`)
        .then(response => {
          let data = response.body
          if (data.code === 0) {
            this.info = data.data
          } else {

          }
        }, response => {
        // error callback
        })
    }
  },
  mounted () {
    this.getInfo()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  @import "../index.less";
  .s-profile{
    padding: 15px;
    position: relative;
    &-bg{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      filter:blur(2px);
      opacity: 0.2;
      background-position: center;
      background-size: 100%;
    }
    &:before,
    &:after{
      content: "";
      display: table;
      clear: both;
    }
    .avator{
      width:105px;
      height: 105px;
      border-radius: 50%;
      float: left;
      position: relative;
      z-index: 2;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }
    &-info{
      padding-left: 120px;
      font-size: 12px;
      color: #9F9EA0;
        position: relative;
      z-index: 2;
      h3{
        color:#fff;
        font-size: 24px;
      }
    }
  }
  .label-group{
    margin-top: 8px;
  }
  .s-label{
    font-size: 12px;
    color:#fff;
    background-color: #6758EA;
    border-radius: 14px;
    padding:3px 6px;
    margin-right: 8px;
  }
  .s-figure-list{
    &>li>{
      background-color: #0e0f1a;
      img,video{
        width: 100%
      }
    }
  }
  .empty-tips{
    text-align: center;
    font-size: 12px;
    height: 30px;
    line-height: 30px;
    color: #9F9EA0;
  }
</style>



// WEBPACK FOOTER //
// src/containers/info/Index.vue